// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"TagsDropdown_ItemsWrapper__q134W","Slide":"TagsDropdown_Slide__AgpSg","Active":"TagsDropdown_Active__-XVIj"};